import { Nullable } from "../../../types/common";
import { ProductFieldStatus } from "../features/product-status-indicator/types/product-field-status.type";

export const getSavingsBadgeStatus = (
  badge: Nullable<string>,
  wasBadgeUpdated: boolean
): ProductFieldStatus => {
  if (wasBadgeUpdated && badge === null) {
    return "removed";
  }
  if (wasBadgeUpdated) {
    return "system_overwritten";
  }
  return "none";
};
